import { createSlice } from '@reduxjs/toolkit'

export const ProjectListSearchSlice = createSlice({
  name: 'project_list_search',
  initialState: {
    value: '',
  },
  reducers: {
    projectListSearch: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { projectListSearch } = ProjectListSearchSlice.actions

export default ProjectListSearchSlice.reducer